import React, { FC } from 'react';
import { CSVLink } from 'react-csv';
import { Paper, AdminFormHeader } from '../../../components/UI';
import { DarkBlueBodyL, DarkBlueBodyS, RedHeaderS } from '../../../Themes';
import { ButtonWrapper, FileData } from '../Styles';
import { Button } from '../../../components/UI';
import { BulkUploadPointsResponse } from '../../../lib/Api/Admin';

interface DownloadPointsAllocationProps {
  onCancel: () => void;
  data: BulkUploadPointsResponse & {
    eventId: number;
    reward: any;
    companyId?: number;
  };
}

const DownloadPointsAllocation: FC<DownloadPointsAllocationProps> = ({ onCancel, data }) => {
  const fileName = `PointsAllocation_${data.reward?.type || 'Reward'}_${data.reward?.points || 0}points_${new Date().toISOString().split('T')[0]}`;
  // Check if we have data to show
  const hasData = data.result?.totalProcessed !== undefined || data.result?.totalErrors !== undefined;
  const totalProcessed = data.result?.totalProcessed || 0;
  const totalSuccess = data.result?.totalSuccess || 0;
  const totalErrors = data.result?.totalErrors || 0;

  return (
    <>
      <AdminFormHeader title={'Points Allocation Results'} onClick={onCancel} backBtn={true} />
      <Paper width={'60%'}>
        <DarkBlueBodyS>
          {data.result?.totalErrors === 0 
            ? 'Points allocation has been completed successfully. You can download the results below.'
            : 'Points allocation encountered some issues. Please review the results below.'
          }
        </DarkBlueBodyS>
        
        <FileData>
          <DarkBlueBodyL>Points Allocation Summary</DarkBlueBodyL>
          <DarkBlueBodyS>
            {`Reward: ${data.reward?.name || 'N/A'} | Points: ${data.reward?.points || 0} | Type: ${data.reward?.type || 'N/A'} | Event ID: ${data.eventId}`}
            {data.companyId && ` | Company ID: ${data.companyId}`}
          </DarkBlueBodyS>
          <DarkBlueBodyS>
            {`Total Processed: ${totalProcessed} | Success: ${totalSuccess} | Errors: ${totalErrors}`}
          </DarkBlueBodyS>
        </FileData>

        {hasData && (
          <ButtonWrapper>
            <Button variant={'admin-primary'}>
              <CSVLink 
                headers={[
                  { label: 'Event ID', key: 'eventId' },
                  { label: 'Reward Name', key: 'rewardName' },
                  { label: 'Points', key: 'points' },
                  { label: 'Reward Type', key: 'rewardType' },
                  { label: 'Company ID', key: 'companyId' },
                  { label: 'Status', key: 'status' },
                  { label: 'Details', key: 'details' }
                ]} 
                data={[
                  // Add success entries
                  ...(data.result?.success?.map(successItem => {
                    const item = successItem as any;
                    const details = item.email || item;
                    return {
                      eventId: data.eventId,
                      rewardName: data.reward?.name || 'N/A',
                      points: data.reward?.points || 0,
                      rewardType: data.reward?.type || 'N/A',
                      companyId: data.companyId || 'N/A',
                      status: 'SUCCESS',
                      details: details
                    };
                  }) || []),
                  // Add error entries
                  ...(data.result?.errors?.map(errorItem => ({
                    eventId: data.eventId,
                    rewardName: data.reward?.name || 'N/A',
                    points: data.reward?.points || 0,
                    rewardType: data.reward?.type || 'N/A',
                    companyId: data.companyId || 'N/A',
                    status: 'ERROR',
                    details: errorItem
                  })) || [])
                ]} 
                filename={`${fileName}_detailed.csv`}
              >
                Download Report
              </CSVLink>
            </Button>
          </ButtonWrapper>
        )}

        {!hasData && (
          <RedHeaderS>No data available for download</RedHeaderS>
        )}
      </Paper>
    </>
  );
};

export default DownloadPointsAllocation; 